// extracted by mini-css-extract-plugin
export default {"summary":"payment_summary__CXxnR","checkbox":"payment_checkbox__FeL3c","method":"payment_method__V+1Qt"};